import type { ReactNode } from "react";
import { CostEstimateInfoIcon } from "./cost-estimate-tooltip";
import { LoadingSpinner } from "./loading";
import { tokens } from "./tokens";

export function DetailLabel({
  as: Tag = "h3",
  label,
  tooltip,
  isLoading = false,
  className = "",
}: {
  as?: "h3" | "h4";
  label: ReactNode;
  tooltip?: string;
  isLoading?: boolean;
  className?: string;
}) {
  return (
    <Tag
      className={`${tokens.type["micro label"]} flex items-center gap-1 ${className}`}
    >
      {label}
      {tooltip != null ? (
        <CostEstimateInfoIcon
          text={tooltip}
          ariaLabel={`More information: ${label}`}
        />
      ) : null}
      <LoadingSpinner variant="xs" show={isLoading} />
    </Tag>
  );
}
